export const DEFAULT_CANVAS_WIDTH = 200;
export const DEFAULT_CANVAS_HEIGHT = 800;
export const CANVAS_FONT = '16px Ubuntu Mono';
export const CANVAS_TEXT_ALIGN = 'center';
export const MARGIN_LEFT = 100;
export const MARGIN_BOTTOM = 50;
export const BASE_Y = 100;
export const TOP_X = 0;
export const TOP_Y = 0;
export const GAP_BETWEEN_PARTICIPANTS = 200;
export const LIFELINE_DASH_PATTERN = [5, 3];
export const HALF_PARTICIPANT_WIDTH = 50;
